import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["userId", "portalId", "children"];
import UILink from 'UIComponents/link/UILink';
import { getUserContactPageUrl } from '../usersUtils';
import styled from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
const UserLink = _ref => {
  let {
      userId,
      portalId,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const userHref = getUserContactPageUrl(userId, portalId);
  return /*#__PURE__*/_jsx(UILink, Object.assign({
    target: "_blank"
  }, props, {
    href: userHref,
    children: children
  }));
};
export const UserLinkWithExternalIcon = styled(UserLink).withConfig({
  displayName: "UserLink__UserLinkWithExternalIcon",
  componentId: "r0a30p-0"
})(["display:flex;align-items:center;span[data-icon-name='externalLink']{transform:translateY(1px);}"]);
export default UserLink;